<footer class="before-login text-center">
    <p>© Genie, All Rights Reserved.</p>
</footer>